import { render, staticRenderFns } from "./ComLinkageAlert.vue?vue&type=template&id=db258cd2&scoped=true&"
import script from "./ComLinkageAlert.vue?vue&type=script&lang=js&"
export * from "./ComLinkageAlert.vue?vue&type=script&lang=js&"
import style0 from "./ComLinkageAlert.vue?vue&type=style&index=0&id=db258cd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db258cd2",
  null
  
)

export default component.exports